<template>
  <div
    v-if="!!reports?.length"
    class="report-list__container"
  >
    <div class="report-list__inner-container">
      <div class="report-list__list-container">
        <div
          v-for="item in reports"
          :key="item.timeStart"
          class="report-list__item"
        >
          <span v-if="!item.timeFinish && !!item.name">{{ item.name }}</span>
          <span v-if="!item.timeFinish && !item.name">Informe cargando</span>
          <a
            v-if="!!item.timeFinish && !!item?.url"
            :href="item.url"
            :download="item.name + '.' + item.extension"
            target="_blank"
            @click="openBlobNewTab(item)"
          >
            <span v-if="!!item.name">{{ item.name }}</span>
            <span v-if="!item.name">Informe completo</span>
          </a>
          <div class="report-list__item-control">
            <span
              v-if="!item.timeFinish"
              v-tooltip="'Cargando'"
              class="report-list__icon report-list__icon-loading pi pi-spin pi-cog mr-3"
            ></span>
            <span
              v-if="!!item.timeFinish"
              v-tooltip="'Completado'"
              class="report-list__icon report-list__icon-complete pi pi-check-circle mr-3"
            ></span>
            <Button
              v-tooltip="'Cerrar'"
              class="mc-row__button"
              icon="pi pi-times"
              rounded
              raised
              @click="removeReport(item.timeStart)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="reports?.length > 1"
        class="report-list__list-info-container p-3"
      >
        <Button
          v-tooltip="'Cerrar todos'"
          class="mc-row__button"
          icon="pi pi-times"
          rounded
          raised
          @click="removeAllReports()"
        />
        <span
          v-if="!!listInfo"
          class="report-list__list-info pt-2"
        >{{ listInfo }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';
import Button from 'primevue/button';

// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const reports = computed(() => store.getters['reports/reportsByTimeStart']);
const listInfo = computed(() => {
  if (!!reports?.value?.length) {
    return reports.value.length + ' informes';
  }
  return null;
});
// #endregion

// #region Functions
async function removeReport(timeStart) {
  await store.dispatch('reports/removeReportUrl', {timeStart});
}
async function removeAllReports() {
  await store.dispatch('reports/cleanReportUrls');
}
async function openBlobNewTab(item) {
  if (item.url.startsWith('blob')) {
    window.open(item.url, '_blank');
  }
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
$report-list-height-max: 15vh;

.report-list {
  &__container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    z-index: 9999;
    width: 100%;
    margin: 0 auto;
    height: auto;
    overflow-y: auto;
  }
  &__inner-container {
    display: flex;
    position: static;
    flex-direction: row;
    background: none;
    height: auto;
  }
  &__list-info-container {
    display: flex;
    /* gap: 6vh; */
    justify-content: space-between;
    flex-direction: column;
    border-left: 1px solid #a19f9d;
    box-sizing: border-box;
    align-items: center;
    height: auto;
    background: white;
  }
  &__list-container {
    background: white;
    min-width: 20dvw;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow-y: auto;
    max-height: $report-list-height-max;
  }
  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    &-control {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
    &:first-child {
      padding-top: 1rem;
    }
    &:last-child {
      padding-bottom: 1rem;
    }
    padding: 0.5rem 1rem;
    display: flex;
    flex-direction: row;
    padding: 0.5rem 1rem;
    align-items: center;
    align-content: space-around;
    gap: 1rem;
    background: white;
  }
  &__icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  &__icon-loading {
    font-size: 1.5rem;
    color: blue;
  }
  &__icon-complete {
    font-size: 1.5rem;
    color: green;
  }
}
</style>
